import { useContext } from "react";

import { ThemeContext } from "@/shared/lib/contexts/ThemeContext";
import { AppTheme } from "@/shared/const/storageKeys";

export enum Theme {
  Light = "lightTheme",
  Dark = "darkTheme",
}

interface UseThemeResult {
  toggleTheme: () => void;
  theme: Theme;
}

export function useTheme(): UseThemeResult {
  const { theme, setTheme } = useContext(ThemeContext);

  const toggleTheme = () => {
    let newTheme: Theme;

    switch (theme) {
      case Theme.Dark:
        newTheme = Theme.Light;
        break;
      case Theme.Light:
        newTheme = Theme.Dark;
        break;
      default:
        newTheme = Theme.Light;
        break;
    }

    setTheme?.(newTheme);
    localStorage.setItem(AppTheme, newTheme);
  };

  return {
    theme: theme || Theme.Light,
    toggleTheme,
  };
}
